// Import the necessary functions from 'vue-router'
import { createRouter, createWebHistory } from "vue-router";
import RootView from "../views/RootView.vue";

const routes = [
    { path: "/admin/:pathMatch(.*)*", sensitive: true, name: "Admin", component: () => import("../views/AdminEntry.vue") },
    {
        path: "/",
        name: "Home",
        component: RootView,
    },
    {
        path: "/e/:id/:pathMatch(.*)*",
        name: "Event",
        component: () => import("../views/EventPage.vue"),
    },
    {
        path: "/preferences",
        name: "Preferences",
        component: () => import("../views/PreferencesView.vue"),
    },
    {
        path: "/about",
        name: "About",
        component: () => import("../views/AboutView.vue"),
    },
    {
        path: "/affiliate",
        name: "Affiliate",
        component: () => import("../views/AffiliateView.vue"),
    },
    {
        path: "/support",
        name: "Support",
        component: () => import("../views/SupportView.vue"),
    },
    {
        path: "/privacy",
        name: "Privacy",
        component: () => import("../views/PrivacyView.vue"),
    },
    {
        path: "/tos",
        name: "Terms Of Service",
        component: () => import("../views/TermsView.vue"),
    },
    {
        path: "/csae",
        name: "CSAE Standards",
        component: () => import("../views/CSAEStandards.vue"),
    },
    {
        path: "/unsubscribe",
        name: "Unsubscribe",
        component: () => import("../views/UnsubscribeView.vue"),
    },
    {
        path: "/faq",
        redirect: "/docs",
    },
    {
        path: "/docs",
        name: "Docs",
        component: () => import("../views/DocsView.vue"),
    },
    {
        path: "/docs/:pathMatch(.*)*",
        name: "DocsPage",
        component: () => import("../views/DocsView.vue"),
    },
    {
        path: "/:catchAll(.*)",
        name: "NotFoundPage",
        component: () => import("../views/NotFoundPage.vue"),
    },
];

// Create the router using the new Vue 3 compatible methods
const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to) => {
    const targetAdmin = to.path === "/admin" || to.path.startsWith("/admin/");
    const currentAdmin = window.location.pathname.toLowerCase() === "/admin" || window.location.pathname.toLowerCase().startsWith("/admin/");
    if (targetAdmin !== currentAdmin) {
        window.location.assign(to.fullPath);
        return false;
    }
});

export default router;
